import { createContext } from 'react';
import { fetchBOL } from '../api/fetchBOL';

export { fetchBOL } from '../api/fetchBOL';
export const BOLContext = createContext({ fetchBOL });
